import type { MeaterProductVariant } from '@src/domain/types/MeaterProduct';
import ColorVariantSelector from './_ColorVariantSelector';
import GeneralVariantSelector from './_GeneralVariantSelector';

interface VariantSelectorProps {
  variants: Array<MeaterProductVariant>;
  activeVariantId?: string;
}

const VariantSelector = ({ variants, activeVariantId }: VariantSelectorProps) => {
  const optionNames = [...new Set(variants.flatMap((v) => v.selectedOptions.map((o) => o.name)))];

  return (
    <>
      {optionNames.map((optionName) => {
        if (optionName.toLowerCase() === 'color') {
          return (
            <ColorVariantSelector
              key={optionName}
              variants={variants}
              activeVariantId={activeVariantId}
            />
          );
        }
        return (
          <GeneralVariantSelector
            key={optionName}
            optionName={optionName}
            variants={variants}
            activeVariantId={activeVariantId}
          />
        );
      })}
    </>
  );
};

export default VariantSelector;
